// FAQ data — applies to all 901 Lots services (striping, sealcoating, ADA,
// restriping, pavement marking, crack filling). Rendered as accordion on the
// /faq page and as a homepage section. Also emitted as FAQPage JSON-LD for
// Google rich snippets.

export const FAQS = [
  {
    q: "How much does parking lot striping or sealcoating cost?",
    a: "Every job is priced differently because every lot is different. Sealcoating and pothole patching are priced per square foot, while striping, restriping, crack filling, and curb painting are priced per linear foot. Painted ADA symbols, directional arrows, and custom stencils are priced per item. Final pricing depends on the size, layout, and current condition of your lot — heavily cracked or oxidized pavement takes more material and prep than a recently sealed lot. We schedule a free on-site walk so we can give you a fixed-price written quote rather than a guess. Discounts are available for churches and for ongoing recurring maintenance contracts.",
  },
  {
    q: "How long will my parking lot be inaccessible during the work?",
    a: "Most striping projects are completed in a few hours and most sealcoat applications cure overnight. For larger lots we work in sections so part of the lot stays open. We schedule the bulk of the work after-hours so your business is rarely affected.",
  },
  {
    q: "What paint and materials do you use?",
    a: "We use commercial-grade traffic paint, hot-applied rubberized crack filler, and pro-grade asphalt sealer — never the consumer-grade stuff that fades in a season. For high-wear areas we can also apply thermoplastic markings on request.",
  },
  {
    q: "Do you offer ADA-compliant striping and signage?",
    a: "Yes. We provide full ADA layouts including accessible stalls, van-accessible access aisles, International Symbol of Access markings, and properly mounted signage at compliant heights. We're happy to do a free ADA compliance walk-through on your existing lot.",
  },
  {
    q: "How long does the paint and sealer take to dry?",
    a: "Fresh traffic paint typically dries within 15–30 minutes in normal conditions. Sealcoating needs at least 24 hours of cure time (and often 48 in humid Mid-South summers) before reopening to traffic. We'll tell you exactly when each section is safe to drive on.",
  },
  {
    q: "Can you design a layout for a new parking lot?",
    a: "Absolutely. We design new-lot layouts to maximize stall count, optimize traffic flow, and meet current ADA standards. If you're planning a new build or major resurface, get us involved early — small layout choices can add real stall capacity.",
  },
  {
    q: "Do you re-stripe existing parking lots?",
    a: "Restriping is one of our most common jobs. If your current layout works, we mask and repaint over the existing lines using quick-dry traffic paint — usually completed in a single overnight visit at a fraction of the cost of a new layout.",
  },
  {
    q: "Can you work at night or on weekends?",
    a: "Yes — most of our work happens overnight or on weekends specifically so your business never shuts down. Crews mobilize from Memphis and we can run multiple shifts to compress timelines on large lots.",
  },
  {
    q: "Do you install wheel stops, bollards, and signage?",
    a: "Yes. We install and paint wheel stops, bollards, directional arrows, curb markings, fire-lane striping, speed bumps, and any ADA or traffic signage your property needs.",
  },
  {
    q: "How long does the striping and sealcoating last?",
    a: "Fresh striping typically holds up 12–24 months depending on traffic volume and weather. Sealcoat protects asphalt for 2–3 years in Memphis-area conditions before it needs a refresh. We recommend annual crack-fill between full sealcoats to extend pavement life by 5–10 years.",
  },
  {
    q: "What makes 901 Lots different?",
    a: "We're a small, local crew based in Memphis — not a franchise or call center. We answer the phone, we show up on time, we use commercial-grade materials, and we give you a fixed-price written quote up front. If a line is crooked, we hear about it at the grocery store — so we don't paint crooked lines.",
  },
  {
    q: "Do you offer free estimates?",
    a: "Yes. Every quote is free, fixed-price, and obligation-free. Submit the free quote form or call us — we'll come walk the lot and typically send your written quote within 48 hours.",
  },
  {
    q: "How far outside Memphis do you travel?",
    a: "We serve roughly a two-hour radius of Memphis — across West Tennessee, North Mississippi, and Eastern Arkansas. See our 20 named service areas for the full list, or just ask: we travel for the right project.",
  },
];
